import * as React from 'react'
import {
	DragSource,
	DropTarget
} from 'react-dnd';
import { flow } from 'lodash';
import { TYPE } from './CardDND';
import CardBox from './Card';
import { API } from '../../../../helper/api';

const cardSource = {
	beginDrag(props) {
		return {
			id: props.id,
			eventId: props.event.id,
			originalIndex: props.findCard(props.id).index,
		}
	},

	endDrag(props, monitor) {
		const { eventId } = monitor.getItem() // originalIndex : draggedId
		const didDrop = monitor.didDrop()
		const originalIndex = props.findCard(props.id).index;

		if (didDrop) {
			API.patch('topevent/order/'+eventId+'/'+ (originalIndex + 1))//.then(() => 
				//props.moveCard(draggedId, originalIndex)
				
			//)
		}
	},
}

const cardTarget = {
	canDrop() {
		return true
	},

	hover(props, monitor) {
		const { id: draggedId } = monitor.getItem()
		const { id: overId } = props

		if (draggedId !== overId) {
			const { index: overIndex } = props.findCard(overId);
			props.moveCard(draggedId, overIndex);
		}
	},
}

export class Card extends React.Component {
	render() {
		const {
			event,
			isDragging,
			connectDragSource,
			connectDropTarget,
		} = this.props
		const opacity = isDragging ? 0 : 1

		return (
			connectDragSource &&
			connectDropTarget &&
			connectDragSource(
				connectDropTarget(<div className="ant-col-xs-24 ant-col-sm-24 ant-col-md-12 ant-col-lg-6 ant-col-xl-6" style={{ opacity, marginTop: '50px', maxWidth: '250px', position: 'relative'  }} >
						<CardBox onRemove={() => { this.props.onRemove(event.id) }} event={event}/>
					</div>),
			)
		)
	}
}

export default flow(
	DropTarget(TYPE.CARD, cardTarget, connect => ({
		connectDropTarget: connect.dropTarget(),
	})),
	DragSource(TYPE.CARD, cardSource, (connect, monitor) => ({
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging(),
	})))(Card)



// WEBPACK FOOTER //
// ./src/features/admin/events/item/CardDND.bis.js